import { render, staticRenderFns } from "./addToAlbumBtn.vue?vue&type=template&id=1175456b&scoped=true"
import script from "./addToAlbumBtn.vue?vue&type=script&lang=js"
export * from "./addToAlbumBtn.vue?vue&type=script&lang=js"
import style0 from "./addToAlbumBtn.vue?vue&type=style&index=0&id=1175456b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1175456b",
  null
  
)

export default component.exports